import React, { useState, useEffect, useRef } from "react";
import { Link, Outlet } from "react-router-dom";
import "./Navbar.css";
import { RxHamburgerMenu } from "react-icons/rx";
import { RxCross1 } from "react-icons/rx";

import Logo from "../../assets/images/Apischain logo .png";

import { BsInstagram, BsLinkedin } from "react-icons/bs";
import { FaFacebookSquare } from "react-icons/fa";
import { AiFillTwitterSquare } from "react-icons/ai";
import { IoLogoYoutube } from "react-icons/io";
const Navbar = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (click && menuRef.current && !menuRef.current.contains(e.target)) {
        setClick(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [click]);

  return (
    <div>
      <nav className="navbar p-0">
        <div className="nav-container container d-flex align-items-center justify-content-between">
          <div className="logo-container">
            <Link to="/">
              <img alt="Logo" src={Logo} />
            </Link>
          </div>
          <div className="nav-icon" onClick={handleClick}>
            {click ? <RxCross1 /> : <RxHamburgerMenu />}
          </div>

          <div
            ref={menuRef}
            className={`${click ? "nav-menu active" : "nav-menu"} d-flex `}
          >
            <div className="d-flex justify-content-lg-end nav-item-container ">
              <ul className="d-flex mb-0 list-unstyled nav-rt">
                <li className="nav-item">
                  <a
                    href="https://siapischain-abn.gbrapp.com/"
                    target="_blank"
                    rel="noreferrer"
                    className="nav-links"
                    onClick={Close}
                  >
                    Login
                  </a>
                </li>
              </ul>

              <ul className="d-flex mb-0 list-unstyled  nav-lf">
                <li className="mobile-visible">
                  <a
                    rel="noopener noreferrer"
                    className="icon-container"
                    href="https://www.facebook.com/profile.php?id=100094453486891"
                    target="_blank"
                    onClick={Close}
                  >
                    <FaFacebookSquare />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    href="https://instagram.com/livasanatural.honey?igshid=MzNlNGNkZWQ4Mg=="
                    target="_blank"
                    className="icon-container"
                    onClick={Close}
                  >
                    <BsInstagram />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    href="https://www.linkedin.com/company/livasa-natural/"
                    target="_blank"
                    className="icon-container"
                    onClick={Close}
                  >
                    <BsLinkedin />
                  </a>

                  <a
                    rel="noopener noreferrer"
                    href="https://instagram.com/livasanatural.honey?igshid=MzNlNGNkZWQ4Mg=="
                    target="_blank"
                    className="icon-container icon-container--modt"
                    onClick={Close}
                  >
                    <AiFillTwitterSquare />
                  </a>
                  <a
                    rel="noopener noreferrer"
                    href="https://youtube.com/@livasanatural72?si=OyboV_F2rNhd3ciE"
                    target="_blank"
                    className="icon-container icon-container--mody"
                    onClick={Close}
                  >
                    <IoLogoYoutube />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      <Outlet />
    </div>
  );
};

export default Navbar;
